import React from 'react';
import {AlertModal, ModalDangerButtons} from 'components/modals';

const ArchiveCycleModal = ({archiveCycle, onCancel, onArchive}) => {
  return (
    <AlertModal
      isOpen={archiveCycle !== null}
      onHide={onCancel} size='sm'
      header='performance.Archive Check-In Cycle'
      subHeader='performance.Are you sure you want to archive this check-in cycle?'
      body='performance.Archived check-in cycles will no longer be actionable but the check-ins will remain visible to admins.' >

      <ModalDangerButtons
        onCancel={onCancel}
        saveCaption='performance.Archive'
        onSave={() => onArchive(archiveCycle)} />
    </AlertModal>
  );
};

export default ArchiveCycleModal;
